import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Swiper, SwiperSlide} from "swiper/react";
import { Autoplay } from "swiper";
import './BrandFocusSlider.css'
import {NavLink} from "react-router-dom";

const maleBrandContext = require.context(
    "../../assets/brandImages/male",
    true,
    /\.(png|jpe?g|svg|webp)$/
);
const femaleBrandContext = require.context(
    "../../assets/brandImages/female",
    true,
    /\.(png|jpe?g|svg|webp)$/
);
function getAllBrandImages(context) {
    try {
        const keys = context.keys().sort();
        return keys.map((k) => {
            const mod = context(k);
            const src = mod && mod.default ? mod.default : mod;
            const fileBase = k.replace(/^\.\//, '').replace(/\.[^/.]+$/, '');
            return { src, fileBase };
        });
    } catch (err) {
        console.warn("Error loading images from LandingPageSlider", err);
        return [];
    }
}
const femaleBrandImages = getAllBrandImages(femaleBrandContext);
const maleBrandImages = getAllBrandImages(maleBrandContext);
const femaleBrands = [
    'parfois',
/* 'mango',*/
 'hugo',
 'boss',
 'guess',
 'guess-jeans',
 'replay',
/* 'EA7',*/
 'armani-exchange',
 'guess-accessories',
 'timberland',
 'springfield',
 'women-secret',
 'geox',
 'gant',
 'calvin-klein-jeans',
 'calvin-klein-underwear',
 'tommy-hilfiger',
/* 'tom-tailor',*/
 /*'stilium',*/
 'xyz',
'plein-sport',
'carpisa'
]


const maleBrands = [
    'hugo',
    'boss',
    'guess',
    'guess-jeans',
    'replay',
    'EA7',
    'armani-exchange',
    'guess-accessories',
    'timberland',
    'springfield',
    'geox',
    'gant',
    'tom-tailor',
    'stilium',
    'xyz',
    'calvin-klein-jeans',
    'calvin-klein-underwear',
    'calvin-klein-jeans-man',
    'calvin-klein-underwear-man',
    'antony-morato',
    'tommy-hilfiger',
    'mangoman',
    'plein-sport',
    'dan-john',
    'boggi',
    'carpisa',
]

const BrandFocusSlider = ({gender = 'female'}) => {
const [swiper, setSwiper] = useState(null);
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        const imageList =  gender === 'female' ? femaleBrandImages : maleBrandImages;
        const brandList= gender === 'female' ? femaleBrands : maleBrands;
        const imagesByFileBase = new Map(
            imageList.map(({ fileBase, src }) => [String(fileBase).toLowerCase(), src])
        );
        const fetchBrands = async () => {
            try {
                const res = await axios.get(process.env.REACT_APP_BASE_URL + "/getBrands");
                if (res.status === 200) {
                    setBrands(res.data.filter(e=>brandList.includes(e.slug)).map(item=>{
                        const image = imagesByFileBase.get(String(item.slug).toLowerCase());
                        return {...item,image:image}
                    }));
                }
            } catch (error) {
                console.error("Error fetching brands:", error);
            } finally {
            }
        };

        fetchBrands();
    }, [gender]);
    return <div className={'brand-focus-slider'}
                tabIndex={1}
                role="button"
                onMouseEnter={() => swiper?.autoplay?.stop()}
                onMouseLeave={() => swiper?.autoplay?.start()}
       >
        <Swiper
            id={'brand-focus-slider'}
            onSwiper={setSwiper}
            modules={[Autoplay]}
            autoplay={{
                delay: 0,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                stopOnLastSlide: false,
            }}
            spaceBetween={0}
            speed={5000}
            direction={'horizontal'}
            slidesPerView={1}
            freeMode={true}
            loop={true}
            breakpoints={{
                640: {slidesPerView: 3},
                768: {slidesPerView: 4},
                1024: {slidesPerView: 4},
                1280: {slidesPerView: 4},
            }}
            className="!px-4"
        >
            {brands.map((logo ) => (
                <SwiperSlide key={logo.brand}>


                    <NavLink to={`/brands/${logo.slug}`} aria-label={logo.brand}
                       className="group w-full p-4 flex items-center justify-center">
                        <div
                            className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
                            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <img
                                    style={{height: 150,margin: '-25px 0'}}
                                    src={logo.brandImage}
                                    alt={logo.brand}
                                    className="mx-auto object-contain w-full"
                                    loading="lazy"
                                    width="200"
                                    height="100"
                                />
                            </span>
                            <img
                                src={logo.image || logo.brandImage}
                                alt={logo.brand}
                                className="w-full"
                                loading="lazy"
                                width="200"
                                height="80"
                            />
                        </div>
                    </NavLink>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
}

export default BrandFocusSlider;